import script from "./CostBreakdownTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CostBreakdownTable.vue?vue&type=script&setup=true&lang=js"

import "./CostBreakdownTable.vue?vue&type=style&index=0&id=98349e44&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98349e44"]])

export default __exports__